import React, { useState } from 'react';
import { Share2, Copy, Check, Heart } from 'lucide-react';

const MinimalShare = ({ article, language }) => {
  const [copied, setCopied] = useState(false);
  const [liked, setLiked] = useState(false);

  const url = typeof window !== 'undefined' ? window.location.href : '';
  const text = article?.title || '';
  const canShare = typeof navigator !== 'undefined' && navigator.share;

  const handleShare = async () => {
    if (canShare) {
      try {
        await navigator.share({
          title: text,
          text: article?.excerpt || '',
          url: url,
        });
      } catch (err) {
        // If share fails, copy link instead
        if (err.name !== 'AbortError') {
          handleCopy();
        }
      }
    } else {
      handleCopy();
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '12px',
      paddingTop: '20px',
      marginTop: '30px',
      borderTop: '1px solid #e0e0e0'
    }}>
      {/* <span style={{
        fontSize: '14px',
        color: '#999',
        marginRight: '8px'
      }}>
        {language === 'mr' ? 'शेअर करा:' : 'Share:'}
      </span> */}
      
      {/* <button
        onClick={() => setLiked(!liked)}
        style={{
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          border: liked ? '2px solid #ff6b35' : '2px solid #e0e0e0',
          background: liked ? '#ff6b35' : 'white',
          color: liked ? 'white' : '#999',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'all 0.2s',
        }}
        onMouseEnter={(e) => {
          if (!liked) {
            e.currentTarget.style.borderColor = '#ff6b35';
            e.currentTarget.style.color = '#ff6b35';
          }
        }}
        onMouseLeave={(e) => {
          if (!liked) {
            e.currentTarget.style.borderColor = '#e0e0e0';
            e.currentTarget.style.color = '#999';
          }
        }}
      >
        <Heart size={18} fill={liked ? 'currentColor' : 'none'} />
      </button> */}

      <button
        onClick={handleCopy}
        style={{
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          border: copied ? '2px solid #28a745' : '2px solid #e0e0e0',
          background: copied ? '#28a745' : 'white',
          color: copied ? 'white' : '#999',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'all 0.2s',
        }}
        onMouseEnter={(e) => {
          if (!copied) {
            e.currentTarget.style.borderColor = '#ff6b35';
            e.currentTarget.style.color = '#ff6b35';
          }
        }}
        onMouseLeave={(e) => {
          if (!copied) {
            e.currentTarget.style.borderColor = '#e0e0e0';
            e.currentTarget.style.color = '#999';
          }
        }}
      >
        {copied ? <Check size={18} /> : <Copy size={18} />}
      </button>

      <button
        onClick={handleShare}
        style={{
          width: '36px',
          height: '36px',
          borderRadius: '50%',
          border: '2px solid #ff6b35',
          background: '#ff6b35',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          transition: 'all 0.2s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#ff8c42';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#ff6b35';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        <Share2 size={18} />
      </button>
    </div>
  );
};

export default MinimalShare;